import { LayoutList, Lock, Calculator, Activity, ShieldCheck, BookOpen, PanelLeftClose, PanelLeftOpen } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../ui/tooltip";

export const NAV = [
  { id: "board", label: "Deal Board", short: "Board", icon: LayoutList },
  { id: "mine", label: "My Escrows", short: "Escrows", icon: Lock },
  { id: "simulator", label: "Impact Simulator", short: "Sim", icon: Calculator },
  { id: "tape", label: "Trade History", short: "Trades", icon: Activity },
  { id: "trust", label: "Token Trust", short: "Trust", icon: ShieldCheck },
  { id: "docs", label: "How escrow works", short: "Help", icon: BookOpen },
];

export const IconRail = ({ view, setView, collapsed, setCollapsed }) => (
  <TooltipProvider delayDuration={100}>
    <nav className={`hidden lg:flex shrink-0 h-full flex-col border-r border-line bg-s1 transition-[width] duration-200 ${collapsed ? "w-14" : "w-56"}`} data-testid="icon-rail">
      <div className="flex-1 py-3 space-y-1 px-2">
        {NAV.map(({ id, label, icon: Icon }) => {
          const active = view === id;
          const btn = (
            <button
              key={id}
              onClick={() => setView(id)}
              data-testid={`nav-${id}`}
              className={`relative w-full flex items-center gap-3 h-10 rounded px-2.5 text-sm transition-colors duration-150 ${active ? "bg-violet/15 text-white" : "text-fog hover:text-white hover:bg-s2"}`}
            >
              {active && <span className="absolute left-0 top-2 bottom-2 w-0.5 rounded-full bg-violet" />}
              <Icon size={17} className={active ? "text-violet-300" : ""} />
              {!collapsed && <span className="truncate font-medium">{label}</span>}
            </button>
          );
          return collapsed ? (
            <Tooltip key={id}><TooltipTrigger asChild>{btn}</TooltipTrigger><TooltipContent side="right" className="bg-s3 border-line2 text-white text-xs">{label}</TooltipContent></Tooltip>
          ) : btn;
        })}
      </div>
      <button onClick={() => setCollapsed(!collapsed)} className="h-11 border-t border-line flex items-center justify-center text-fog hover:text-white transition-colors" data-testid="rail-toggle-btn">
        {collapsed ? <PanelLeftOpen size={16} /> : <PanelLeftClose size={16} />}
      </button>
    </nav>
  </TooltipProvider>
);

// Bottom tab bar for phones/tablets — replaces the left sidebar below the lg breakpoint.
export const MobileNav = ({ view, setView }) => (
  <nav className="lg:hidden fixed bottom-0 inset-x-0 z-40 h-14 border-t border-line bg-s1/95 backdrop-blur-md grid grid-cols-6" data-testid="mobile-nav">
    {NAV.map(({ id, short, icon: Icon }) => {
      const active = view === id;
      return (
        <button key={id} onClick={() => setView(id)} data-testid={`mobile-nav-${id}`}
          className={`flex flex-col items-center justify-center gap-1 transition-colors ${active ? "text-violet-300" : "text-fog"}`}>
          <Icon size={19} />
          <span className="text-[9px] font-medium tracking-tight leading-none">{short}</span>
        </button>
      );
    })}
  </nav>
);
